// ── Llamada normal (sin streaming) ────────────────────────────────────────
export async function callClaude(messages, system, maxTokens = 1000, jsonMode = false, useMini = false) {
  const res = await fetch("/api/claude", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      max_tokens: maxTokens,
      system,
      messages,
      ...(jsonMode  ? { json_mode:  true } : {}),
      ...(useMini   ? { use_mini:   true } : {}),
    }),
  });
  const data = await res.json();
  if (data.error) throw new Error(data.error.message || JSON.stringify(data.error));
  return data.content?.map(b => b.text || "").join("") || "";
}

// ── Streaming real con reader.read() loop ─────────────────────────────────
// onChunk(delta, fullSoFar) se llama por cada fragmento de texto recibido.
// Retorna Promise<string> con el texto completo.
// signal: AbortSignal opcional para cancelar el stream antes de que termine.
export async function callClaudeStreaming(messages, system, onChunk, maxTokens = 1000, signal) {
  const res = await fetch("/api/claude", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      max_tokens: maxTokens,
      system,
      messages,
      stream: true,
    }),
    signal,
  });

  if (!res.ok) {
    const err = await res.text();
    throw new Error(err);
  }

  const reader  = res.body.getReader();
  const decoder = new TextDecoder();
  let sseBuffer = "";
  let fullText  = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      sseBuffer += decoder.decode(value, { stream: true });
      const lines = sseBuffer.split("\n");
      sseBuffer   = lines.pop();

      for (const line of lines) {
        if (!line.startsWith("data: ")) continue;
        const payload = line.slice(6).trim();
        if (payload === "[DONE]") continue;
        try {
          const parsed = JSON.parse(payload);
          if (parsed.type === "content_block_delta" && parsed.delta?.text) {
            fullText += parsed.delta.text;
            onChunk(parsed.delta.text, fullText);
          }
        } catch { /* ignorar líneas malformadas */ }
      }
    }
  } catch (e) {
    if (e.name === "AbortError") return fullText;
    throw e;
  } finally {
    reader.releaseLock();
  }

  return fullText;
}
